import { render, staticRenderFns } from "./CeisaPpjkEdit.vue?vue&type=template&id=5659b36a&scoped=true&"
import script from "./CeisaPpjkEdit.vue?vue&type=script&lang=js&"
export * from "./CeisaPpjkEdit.vue?vue&type=script&lang=js&"
import style0 from "./CeisaPpjkEdit.vue?vue&type=style&index=0&id=5659b36a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5659b36a",
  null
  
)

export default component.exports